export default "<div class=\"page-title\">\n    <h1>{{$ctrl.title}}</h1>\n</div>";